module.exports = __webpack_public_path__ + "img/logo.3d16d367.png";